import { createReducer, on } from '@ngrx/store';
import {
  PLAccountsError,
  PLAccountsPending,
  PLAccountsSuccess,
} from './actions';
import { PLAccountsState } from './state';

const initialState: PLAccountsState = {
  accountsState: 'init',
};

export const reducer = createReducer(
  initialState,
  on(
    PLAccountsPending,
    (state): PLAccountsState => ({
      ...state,
      accountsState: 'pending',
    })
  ),
  on(
    PLAccountsSuccess,
    (state, { account }): PLAccountsState => ({
      ...state,
      accountsState: 'success',
      account,
    })
  ),
  on(
    PLAccountsError,
    (state): PLAccountsState => ({
      ...state,
      accountsState: 'error',
      account: null,
    })
  )
);
